import { Injectable } from '@angular/core';
import { Headers, Http, Response, RequestOptions } from '@angular/http';
import { Observable } from 'rxjs/Observable';
import 'rxjs/add/operator/map';


@Injectable()
export class PayrollRevisionService {
  constructor(private http: Http) { }

  Get_CurrentUserDataLog(TenantID: string) {
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.get('api/PayrollRevisionData/Get_CurrentUserDataLog?TenantID=' + TenantID, options)
      .map(this.Success)
      .catch(this.Error);
  }

  SendMailPayrollRevision(PayrollCheckedData: any) {
    let body: string = JSON.stringify(PayrollCheckedData);
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.post('api/PayrollRevisionData/SendPayrollRevision', body, options)
      .map(this.Success)
      .catch(this.Error);
  }

  ExportAllData(PayrollCheckedData: any) {
    let body: string = JSON.stringify(PayrollCheckedData);
    let headers: Headers = new Headers({ 'Content-Type': 'application/json' });
    let options: RequestOptions = new RequestOptions({ headers: headers });
    return this.http.post('api/PayrollRevisionData/ExportAllData', body, options)
      .map(this.Success)
      .catch(this.Error);
  }

  private Success(res: Response) {
    let body = res.json();
    return body || {};
  }
  private Error(error: any) {
    let errMsg = (error.message) ? error.message :
      error.status ? '${error.status} - ${error.statusText}' : 'Server error';
    console.error(errMsg); // log to console instead
    return Observable.throw(errMsg);
  }
}




// WEBPACK FOOTER //
// ./src/app/Services/PayrollRevisionService.ts